import React, { useEffect, useRef, useState } from "react";
import ArrowButton from "../ArrowButton";
import Modal from "../Modal";
import defaultImgForLiasionAccess from "../../assets/images/svg/defaultImgForLiasionAccess.svg";
import imageIcon from "../../assets/images/svg/imageIcon.svg";
import rightArrowWhite from "../../assets/images/svg/rightArrowWhite.svg";
import cameraIcon from "../../assets/images/svg/cameraIcon.svg";
import addLiaisonOfficer from "../../assets/images/svg/addLiaisonOfficer.svg";
import accountAccessIcon from "../../assets/images/svg/accountAccessIcon.svg";
import AddManager from "../AddManager/AddManager";
import AddedLiaisonOfficer from "../AddedLiaisonOfficer/AddedLiaisonOfficer";
import { toJS } from "mobx";
import { Observer } from "mobx-react";
import SettingsStore from "../../store/SettingsStore";
import { familyOfficeTeamNameText } from "../../utils/constants";

const AddImageModalContent = ({
  uploadMessage,
  setUploadMessage,
  image,
  setImage,
  handleCancel,
  isEdit,
}) => {
  const fileRef = useRef();
  const uploadFile = (fileVar) => {
    const file = getSelectedFile(fileVar);
    const validation = validateFile(file);
    switch (validation) {
      case "file type error":
        setUploadMessage({
          message: "Only JPEG and PNG image formats are supported",
          isError: true,
        });
        setImage(null);
        break;
      case "file size error":
        setUploadMessage({
          message: "File size larger than 10 MB",
          isError: true,
        });
        setImage(null);
        break;
      case "valid file":
        setUploadMessage({
          message: "",
          isError: false,
        });
        setImage(file);
        break;
      default:
        break;
    }
  };

  const validateFile = (file) => {
    const allowedFileExtention = [".png", ".jpeg"];
    const fileExtention = file.name.substring(file.name.lastIndexOf("."));
    const isFileSizevalid = file.exactSize < 10485760;
    const isFileTypeValid = allowedFileExtention.includes(
      fileExtention.toLowerCase()
    );
    if (!isFileTypeValid) {
      return "file type error";
    }
    if (!isFileSizevalid) {
      return "file size error";
    }
    if (isFileSizevalid && isFileTypeValid) {
      return "valid file";
    }
  };

  const getFileSize = (size, decimals = 2) => {
    if (size === 0) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(size) / Math.log(k));
    return parseFloat(size / Math.pow(k, i)).toFixed(dm) + " " + sizes[i];
  };

  const getSelectedFile = (file) => {
    if (file) {
      const fileSrc = URL.createObjectURL(file);
      return {
        name: file.name,
        size: getFileSize(file.size),
        exactSize: file.size,
        type: file.type,
        src: fileSrc,
      };
    } else {
      return null;
    }
  };

  const handleFileClick = () => {
    if (!image) {
      fileRef.current.click();
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const dt = e.dataTransfer;
    const file = dt.files[0];
    uploadFile(file);
  };

  const hanldeInpuChange = (e) => {
    e.preventDefault();
    const _file = e.target.files[0];
    uploadFile(_file);
  };

  const stopDefault = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const getImageType = (type) => {
    switch (type) {
      case "image/png":
        return "PNG";
      case "image/jpeg":
        return "JPEG";
      case "image/jpg":
        return "JPG";
      default:
        return "PNG";
    }
  };

  const handleUpload = () => {
    if (image) {
      setUploadMessage({
        message: "Image uploaded successfully",
        isError: false,
      });
    }
  };
  const handleSave = () => {
    handleCancel();
  };

  return (
    <div className="add_image_container">
      <div className="default_image_name_wrapper">
        <p className={`message ${uploadMessage.isError ? "red_text" : ""}`}>
          {uploadMessage.message}
        </p>
        <img
          onClick={handleFileClick}
          src={image ? image.src : defaultImgForLiasionAccess}
          alt="default"
          className={`${image ? "" : "cursor_pointer"} clickable`}
        />
        <p className="user_name">{familyOfficeTeamNameText}</p>
      </div>
      {image ? (
        <div className="selected_image_container">
          <img src={imageIcon} alt="icon" />
          <p className="file_details">
            {image.name} - {image.size} {getImageType(image.type)} format
          </p>
          <button className="remove_btn" onClick={() => setImage(null)}>
            Remove
          </button>
        </div>
      ) : (
        <div
          onDragEnter={stopDefault}
          onDragOver={stopDefault}
          onDrop={handleDrop}
          className="drap_and_drop_container_border"
        >
          <div className="drap_and_drop_container">
            <p className="drag_drop_text">Drag and drop your image </p>
            <p className="file_support_text">
              Files Supported: JPEG, PNG and Maximum Size: 10 MB
            </p>
          </div>
          <input
            onChange={hanldeInpuChange}
            type="file"
            accept="image/png, image/jpeg"
            style={{ display: "none" }}
            ref={fileRef}
          />
        </div>
      )}

      <div className="bottom_button_container">
        <button className="cencel_btn" onClick={handleCancel}>
          Cancel
        </button>
        <ArrowButton
          type="next"
          label={
            uploadMessage.message === "Image uploaded successfully"
              ? "Save"
              : "Upload"
          }
          disabled={!image}
          onClick={
            uploadMessage.message === "Image uploaded successfully"
              ? handleSave
              : handleUpload
          }
        />
      </div>
    </div>
  );
};

const CommonSmallModal = ({ heading, subText, mainImgJSX, rightBtnText }) => {
  return (
    <div>
      <div class="permit_modal_outer padding_btm16">
        <div class="img_holder"></div>
        {mainImgJSX}
        <h2 class="permit_heading margin15">{heading}</h2>
        <h6 class="permit_msg">{subText}</h6>
        <div class="permit_btn_div marginbtn45">
          <h2 class="cancel_btn">Cancel</h2>
          <h2 class="permit_permission">
            <div class="modalSetRedBtn">
              <label class="per_btn_label2">{rightBtnText}</label>
              <button class="permit_red_btn">
                <img src={rightArrowWhite} alt="arrow" />
              </button>
            </div>
          </h2>
        </div>
      </div>
    </div>
  );
};

const AddLiaisonOfficerModal = () => {
  return (
    <div className="add_liaison_officer_modal_container">
      <img
        className="add_liaison_officer_img"
        src={addLiaisonOfficer}
        alt={familyOfficeTeamNameText}
      />
      <p className="add_liaison_officer_heading">
        Family office team added successfully
      </p>
      <p className="add_liaison_officer_sub_heading">
        You can enable or disable your manager’s access privilages from your
        Account Access settings
      </p>
      <div className="go_to_account_access">
        <div className="img_wrapper">
          <img src={accountAccessIcon} alt="account access" />
        </div>
        <p className="go_to_account_access_text">Go to Account Access</p>
      </div>
    </div>
  );
};

const LiaisonOfficerAccess = () => {
  const [uploadPictureModal, setUploadPictureModal] = useState(false);
  const [removePhotoModal, setRemovePhotoModal] = useState(false);
  const [addLiaisonSuccessModal, setAddLiaisonSuccessModal] = useState(false);
  const [image, setImage] = useState(null);
  const [isEdit] = useState(true);
  const [uploadMessage, setUploadMessage] = useState({
    message: "",
    isError: false,
  });
  const [flag, setFlag] = useState(false);

  const handleCancel = () => {
    setUploadMessage({
      message: "",
      isError: false,
    });
    setImage(null);
    setUploadPictureModal(false);
  };

  useEffect(() => {
    setTimeout(() => {
      setFlag(true);
    }, 3);
  }, []);

  return (
    <Observer>
      {() => (
        <>
          {flag ? (
            <>
              <div className="liaison_access_container">
                <div className="liason_set_2nd_container">
                  {!SettingsStore.liaisonOfficerData ? (
                    <AddManager
                      family_data={toJS(SettingsStore.liaisonOfficerData)}
                    />
                  ) : (
                    <AddedLiaisonOfficer />
                  )}
                </div>
              </div>
              <Modal
                onClose={handleCancel}
                open={uploadPictureModal}
                title={isEdit ? "Update Picture" : "Upload Picture"}
                width={"800px"}
              >
                <AddImageModalContent
                  isEdit={isEdit}
                  uploadMessage={uploadMessage}
                  setUploadMessage={setUploadMessage}
                  image={image}
                  setImage={setImage}
                  handleCancel={handleCancel}
                />
              </Modal>
              {/* <Modal
                onClose={() => setDisableAccessModal(false)}
                open={disableAccessModal}
                width="453px"
                minWidth="453px"
                modalContainerClass="disable_liasion_access_modal"
              >
                <CommonSmallModal
                  heading=""
                  subText=""
                  mainImgJSX={
                    <img
                      src={""}
                      className="user_img"
                      alt="user"
                    />
                  }
                  rightBtnText="Yes, disable"
                />
              </Modal> */}
              <Modal
                onClose={() => setRemovePhotoModal(false)}
                open={removePhotoModal}
                width="438px"
                minWidth="438px"
                modalContainerClass="disable_liasion_access_modal"
              >
                <CommonSmallModal
                  heading="Remove Photo?"
                  subText="You can add image again by clicking on the change image button in Family office team profile"
                  mainImgJSX={
                    <div className="image_bg">
                      <img src={cameraIcon} alt="user" />
                    </div>
                  }
                  rightBtnText="Yes, Remove"
                />
              </Modal>
              <Modal
                onClose={() => setAddLiaisonSuccessModal(false)}
                open={addLiaisonSuccessModal}
                title={`Add ${familyOfficeTeamNameText}`}
                width="754px"
                minWidth="754px"
                modalContainerClass="add_liaison_officer_modal"
              >
                <AddLiaisonOfficerModal />
              </Modal>
            </>
          ) : (
            ""
          )}
        </>
      )}
    </Observer>
  );
};

export default LiaisonOfficerAccess;
